import React, { memo, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay,Pagination,Navigation } from 'swiper';
import {useDispatch, useSelector} from 'react-redux';
import { isNormalZhEnCss } from '../../utils';

import 'swiper/css';
import styles from './styles.module.scss';

import first100 from '../../assets/img/home/two/icons/first100.svg';
import first101 from '../../assets/img/home/two/icons/first101.svg';
import group1 from '../../assets/img/home/two/circles/group1.jpg';
import group2 from '../../assets/img/home/two/circles/group2.jpg';
import group3 from '../../assets/img/home/two/circles/group3.jpg';
import group4 from '../../assets/img/home/two/circles/group4.jpg';

// install Swiper modules
SwiperCore.use([Autoplay, Navigation]);

const Index = memo((props) => {
  const dispatch = useDispatch();
  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const {lang} = useSelector(({localesReducer}) => localesReducer.i18n);

  const [ activeIndex, setActiveIndex ] = useState(0);
  const [circlesClass, setCirclesClass] = useState('circlesOne');

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return  isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return  isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return  isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return  isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };

  const groupOneRef = useRef(null);
  const groupTwoRef = useRef(null);
  const groupThreeRef = useRef(null);
  const groupFourRef = useRef(null);


  const swiperTemp = () => {
    const { data } = props.config;
    return (
        <Swiper
            initialSlide={activeIndex}
            className="serviceAdvantagesSwiper"
            direction={'vertical'}
            spaceBetween={50}
            autoplay={{
              "delay": 4000,
              "disableOnInteraction": false,
            }}
            speed={2000}
            navigation = {{
              nextEl: '.btnsanext',
              prevEl: '.btnsaprev',
            }}
            onInit={(swiper) => {
              setActiveIndex(swiper.activeIndex);
              circlesMethod(swiper.activeIndex);
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.activeIndex);
              circlesMethod(swiper.activeIndex);
            }}
        >
          {data.map(item => {
            return (
                <SwiperSlide key={item.id} style={{ height: 'auto' }}>
                  <div className="iInfo">
                    <h5 className="title"><span>{item.title}</span></h5>
                    <div className="subTitle"><span>{item.subTitle}</span></div>
                    <div className="desc"><span>{item.desc}</span></div></div>
                </SwiperSlide>
            )
          })}
        </Swiper>
    )
  };

 

  const circlesMethod = (aIndex) => {
    switch(aIndex){
      case 0:
        setCirclesClass('circlesOne');
        break;
      case 1:
        setCirclesClass('circlesTwo');
        break;
      case 2:
        setCirclesClass('circlesThree');
        break;
      default:
        setCirclesClass('circlesFore');
        break;
    }
  }

  // 桌面/移动端 first101
  const desktopMobile = () => {
    const overflowStyles = {
      overflow: 'hidden',
      transition: `all 0.5s linear`,
      borderRadius: '100%',
    }
    return (
        <>
          <div 
            className="left"
            ref={props.config.getRefs.leftRef}
            style={props.config.getRefs.leftStyles}
          >
            <div className="lContent">
              <div className="nestPrevBtns">
                <div className="icons">
                  <i className="icon btnsaprev"><img src={activeIndex > 0  ? first100 : first101} alt="" /></i>
                  <i className="icon btnsanext"><img src={activeIndex > 2 ? first101 : first100} alt="" /></i>
                </div>
              </div>
              <div className="information">
                <div className="informationBox">
                  <div className="iNums">
                    <div className="num">
                      <span className="iValue">0{activeIndex+1}</span>
                    </div>
                  </div>
                  <div className="introduce">
                    { swiperTemp() }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div 
            className="right" 
            style={props.config.getRefs.rightStyles}
           >
            <div className="circlesBox">
              <div className={circlesClass}>
                <div className="citem" style={overflowStyles}>
                  <img src={group1} alt="" ref={groupOneRef} onMouseOver={handleGroupOne} onMouseLeave={handleGroupOne} / >
                </div>
                <div className="citem" style={overflowStyles}>
                  <img src={group2} alt="" ref={groupTwoRef} onMouseOver={handleGroupOne} onMouseLeave={handleGroupOne} / >
                </div>
                <div className="citem" style={overflowStyles}>
                  <img src={group3} alt="" ref={groupThreeRef} onMouseOver={handleGroupOne} onMouseLeave={handleGroupOne} / >
                </div>
                <div className="citem" style={overflowStyles}>
                  <img src={group4} alt="" ref={groupFourRef} onMouseOver={handleGroupOne} onMouseLeave={handleGroupOne} / >
                </div>
              </div>
            </div>
          </div>
        </>
    );
  }

  const handleGroupOne = (event) => {
    const transition = `all 1.8s ease 0s`
    if(event.type === "mouseover"){
      event.target.style.transition = transition;
      event.target.style.transform = `scale(1.2)`;
    }else{
      event.target.style.transition = transition;
      event.target.style.transform = `scale(1)`;
    }
  }

  return (
      <div className={normal()}>
        {desktopMobile()}
      </div>
  );
});
export default Index;
